import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={80}
      height={80}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M79.328 22.97a7.235 7.235 0 01-3.204-6.42 1.548 1.548 0 00-1.086-1.557L27.746.073a1.547 1.547 0 00-1.783.652 7.234 7.234 0 01-6.308 3.419 1.542 1.542 0 00-1.494 1.088l-5.447 17.266c-.206.65.03 1.37.598 1.748a7.235 7.235 0 013.204 6.42 1.548 1.548 0 001.086 1.558l47.292 14.92a1.548 1.548 0 001.783-.652 7.234 7.234 0 016.308-3.419 1.542 1.542 0 001.494-1.089l5.447-17.265a1.542 1.542 0 00-.598-1.749z"
        fill="#706C64"
      />
      <path
        d="M79.927 24.719L74.48 41.985a1.543 1.543 0 01-1.495 1.088 7.235 7.235 0 00-6.307 3.419 1.546 1.546 0 01-1.784.652L46.82 41.442c12.662 1.576 25.04-6.049 29.016-18.654.331-1.049.595-2.102.792-3.155a7.22 7.22 0 002.7 3.337c.568.379.805 1.098.6 1.749z"
        fill="#595751"
      />
      <path
        d="M58.569 15.144l-26.25-8.282A2.55 2.55 0 1133.853 2l26.25 8.281a2.55 2.55 0 11-1.534 4.863z"
        fill="#8F8B81"
      />
      <path
        d="M43.877 5.162L27.746.072a1.547 1.547 0 00-1.783.653 7.234 7.234 0 01-6.308 3.419 1.542 1.542 0 00-1.494 1.088l-5.447 17.266c-.206.65.03 1.37.598 1.748a7.235 7.235 0 013.204 6.42 1.548 1.548 0 001.086 1.558l16.131 5.089L43.877 5.162z"
        fill="#E8E4D8"
      />
      <path
        d="M43.877 5.162L33.733 37.313l-15.206-4.797c8.58-2.497 15.792-9.095 18.682-18.255A27.588 27.588 0 0038.386 3.43l5.49 1.732z"
        fill="#D8D4C9"
      />
      <path
        d="M43.877 5.162L33.853 2a2.55 2.55 0 10-1.534 4.862l10.024 3.162 1.534-4.862z"
        fill="#F1EEE0"
      />
      <path
        d="M33.923 4.695a2.55 2.55 0 001.665 3.198l2.88.91a2.55 2.55 0 101.534-4.863l-2.88-.91a2.55 2.55 0 00-3.199 1.665z"
        fill="#fff"
      />
      <path
        d="M71.76 27.47a2.2 2.2 0 00-1.437-2.762l-12.79-4.035a2.201 2.201 0 00-1.324 4.198L69 28.906a2.201 2.201 0 002.76-1.436z"
        fill="#E8E4D8"
      />
      <path
        d="M63.322 22.5l3.567 1.125a2.201 2.201 0 01-1.324 4.198l-3.568-1.125a2.201 2.201 0 011.325-4.199z"
        fill="#F9F8F2"
      />
      <path
        d="M69.37 35.045a2.201 2.201 0 00-1.437-2.76L44.72 24.96a2.2 2.2 0 10-1.324 4.198l23.214 7.324a2.2 2.2 0 002.761-1.437z"
        fill="#E8E4D8"
      />
      <path
        d="M53.614 27.767L64.05 31.06a2.201 2.201 0 01-1.324 4.198l-10.438-3.293a2.201 2.201 0 011.325-4.198z"
        fill="#F9F8F2"
      />
      <path
        d="M19.43 15.591l2.668-1.002a1.414 1.414 0 011.49.316l2.03 2.001c.244.24.567.385.909.405l2.844.169c.55.033 1.032.382 1.233.896l1.04 2.653c.125.319.361.582.666.74l2.53 1.31c.49.254.786.77.761 1.32l-.129 2.847c-.015.342.094.678.308.946l1.778 2.227c.343.431.406 1.023.159 1.516l-1.276 2.548c-.154.306-.19.658-.104.99l.718 2.757c.139.534-.045 1.1-.47 1.45l-2.203 1.808a1.415 1.415 0 00-.497.861l-.466 2.812c-.09.544-.488.986-1.02 1.132l-2.747.757c-.33.09-.616.299-.805.585l-1.568 2.379c-.304.46-.847.702-1.392.62l-2.818-.426a1.415 1.415 0 00-.973.206l-2.4 1.536a1.414 1.414 0 01-1.524 0l-2.401-1.536a1.415 1.415 0 00-.974-.206l-2.817.426a1.414 1.414 0 01-1.392-.62l-1.569-2.38a1.413 1.413 0 00-.805-.584l-2.747-.757a1.414 1.414 0 01-1.02-1.132l-.465-2.812a1.415 1.415 0 00-.498-.861l-2.202-1.809a1.414 1.414 0 01-.47-1.449l.718-2.757c.086-.332.05-.684-.104-.99L.15 31.935a1.414 1.414 0 01.159-1.515l1.778-2.228c.213-.267.323-.604.307-.946L2.265 24.4a1.414 1.414 0 01.762-1.32l2.53-1.311c.304-.158.54-.42.666-.74l1.04-2.653a1.414 1.414 0 011.232-.896l2.845-.169c.342-.02.665-.164.909-.404l2.029-2.001c.392-.388.974-.511 1.49-.317l2.668 1.002c.32.12.674.12.995 0z"
        fill="#FE255F"
      />
      <path
        d="M36.441 34.483c-.153.306-.19.658-.104.99l.718 2.757a1.413 1.413 0 01-.471 1.449l-2.203 1.809a1.41 1.41 0 00-.496.861l-.466 2.812c-.09.544-.488.986-1.02 1.133l-2.746.757a1.41 1.41 0 00-.806.584l-1.568 2.379a1.414 1.414 0 01-1.392.621l-2.818-.427a1.423 1.423 0 00-.973.207l-2.401 1.536a1.42 1.42 0 01-1.524 0l-2.4-1.536a1.427 1.427 0 00-.974-.207l-2.817.427a1.416 1.416 0 01-1.393-.621l-1.569-2.38a1.411 1.411 0 00-.804-.583l-2.748-.758a1.416 1.416 0 01-1.02-1.132l-.44-2.669a17.087 17.087 0 009.39 2.794c9.488 0 17.18-7.69 17.18-17.177a17.1 17.1 0 00-3.807-10.783l2.601.153a1.415 1.415 0 011.234.897l1.04 2.652c.124.32.361.582.666.74l2.529 1.311c.49.254.788.77.762 1.32l-.13 2.846c-.014.344.095.68.309.948l1.778 2.226c.343.43.406 1.023.158 1.516l-1.275 2.548z"
        fill="#E01152"
      />
      <path
        d="M13.37 24.578a3.198 3.198 0 00-3.194 3.194 3.198 3.198 0 003.194 3.194 3.198 3.198 0 003.194-3.194 3.198 3.198 0 00-3.194-3.194zM24.498 35.706a3.198 3.198 0 00-3.194 3.194 3.198 3.198 0 003.194 3.194 3.198 3.198 0 003.194-3.194 3.198 3.198 0 00-3.194-3.194zM12.563 39.706a2.569 2.569 0 010-3.632l9.773-9.773a2.568 2.568 0 113.632 3.633l-9.773 9.772a2.568 2.568 0 01-3.632 0z"
        fill="#FFC751"
      />
      <path
        d="M18.994 29.643l-1.83 1.83a2.569 2.569 0 003.633 3.632l1.83-1.83a2.569 2.569 0 00-3.633-3.632z"
        fill="#FFE059"
      />
      <path
        d="M12.979 77.814l-6.31-23.178a2.964 2.964 0 012.081-3.639l56.194-15.296a2.964 2.964 0 013.638 2.081l6.31 23.179a2.964 2.964 0 01-2.082 3.638L16.617 79.895a2.964 2.964 0 01-3.638-2.081z"
        fill="#FE255F"
      />
      <path
        d="M68.582 37.783l6.31 23.178A2.964 2.964 0 0172.81 64.6l-22.968 6.252c10.845-6.677 16.48-19.921 12.966-32.831a28.426 28.426 0 00-.487-1.605l2.622-.713a2.964 2.964 0 013.638 2.08z"
        fill="#E01152"
      />
      <path
        d="M14.768 52.815a3.334 3.334 0 004.093 2.342l33.65-9.16a3.334 3.334 0 10-1.752-6.435l-33.65 9.16a3.334 3.334 0 00-2.34 4.093z"
        fill="#FC709B"
      />
      <path
        d="M33.57 44.241l-8.814 2.4a3.334 3.334 0 001.752 6.434l8.814-2.4a3.334 3.334 0 10-1.751-6.434z"
        fill="#F7A6C1"
      />
      <path
        d="M49.654 59.004l-2.928.797-2.306-8.47a1.846 1.846 0 10-3.562.97l2.79 10.251a1.846 1.846 0 002.266 1.296l4.71-1.281a1.846 1.846 0 10-.97-3.563zM22.77 59.255a1.334 1.334 0 011.712.028 1.846 1.846 0 102.409-2.798 5.022 5.022 0 00-6.448-.096A4.093 4.093 0 0019 60.294a4.135 4.135 0 002.745 3.185l3.674 1.24a.45.45 0 01.298.345c.043.214-.069.313-.106.345a1.337 1.337 0 01-1.83-.067 1.846 1.846 0 10-2.629 2.594 5.034 5.034 0 006.902.241 4.012 4.012 0 001.282-3.842A4.16 4.16 0 0026.6 61.22l-3.673-1.24a.428.428 0 01-.292-.342.377.377 0 01.136-.384zM60.99 55.918l-4.353 1.185-.425-1.563 2.625-.714a1.846 1.846 0 10-.97-3.563l-2.625.715-.425-1.563 4.352-1.185a1.846 1.846 0 00-.97-3.562l-6.133 1.67a1.846 1.846 0 00-1.297 2.266l2.79 10.25a1.846 1.846 0 002.267 1.297l6.133-1.67a1.846 1.846 0 00-.97-3.563zM41.814 62.4l-6.537-9.293a1.835 1.835 0 00-.757-.621c-.773-.364-1.769-.093-2.25.612-.188.262-.31.575-.338.92l-.925 11.324a1.846 1.846 0 003.669.386l4.171-1.136a1.844 1.844 0 002.967-2.191zm-5.23-1.018l-1.585.431.197-2.404 1.388 1.973z"
        fill="#F9F8F2"
      />
      <path
        d="M44.197 49.991c7.878 0 14.265-6.387 14.265-14.265 0-7.878-6.387-14.264-14.265-14.264-7.878 0-14.264 6.386-14.264 14.264 0 7.878 6.386 14.265 14.264 14.265z"
        fill="#FFC751"
      />
      <path
        d="M58.463 35.726c0 7.878-6.387 14.266-14.265 14.266-.935 0-1.848-.09-2.731-.264 7.034-1.116 12.41-7.21 12.41-14.56 0-6.215-3.845-11.532-9.288-13.702 7.697.208 13.874 6.514 13.874 14.26z"
        fill="#FFAF40"
      />
      <path
        d="M37.622 45.275l.041-.041a2.84 2.84 0 00.114-3.887 8.5 8.5 0 01-2.118-5.621c0-3.692 2.356-6.842 5.643-8.03 1.119-.405 1.849-1.488 1.849-2.678 0-1.98-1.966-3.373-3.827-2.697-5.478 1.99-9.39 7.239-9.39 13.405 0 3.608 1.34 6.903 3.549 9.414a2.84 2.84 0 004.139.135z"
        fill="#FFE059"
      />
      <path
        d="M34.312 25.45a14.291 14.291 0 00-3.042 4.247c-.88 1.884.484 4.047 2.564 4.047h.064a2.831 2.831 0 002.563-1.628 8.568 8.568 0 011.807-2.524 2.838 2.838 0 00.19-3.878l-.038-.044c-1.05-1.24-2.937-1.346-4.108-.22z"
        fill="#FFF370"
      />
      <path
        d="M39.143 27.77a2.905 2.905 0 00-2.902 2.902c0 1.6 1.302 2.902 2.902 2.902s2.901-1.302 2.901-2.902-1.301-2.902-2.901-2.902zM49.252 37.88a2.905 2.905 0 00-2.901 2.901c0 1.6 1.301 2.902 2.901 2.902 1.6 0 2.902-1.302 2.902-2.902s-1.302-2.901-2.902-2.901zM38.41 41.514a2.333 2.333 0 010-3.3l8.879-8.878a2.333 2.333 0 113.3 3.3l-8.879 8.878a2.333 2.333 0 01-3.3 0z"
        fill="#FE255F"
      />
      <path
        d="M44.253 32.372l-1.662 1.662a2.333 2.333 0 103.3 3.3l1.662-1.662a2.333 2.333 0 10-3.3-3.3z"
        fill="#FC709B"
      />
    </svg>
  );
}

export default SvgComponent;
